import React from 'react'
import style from './Header.module.sass'
import { neon, pink } from '../styles/themes'

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
} from "react-share";


const Header = (props) => {

    const shareUrl = 'https://bleedproud.netlify.com/';

    //Get today's date
    const monthNames = ["January", "Feb", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    let tempDate = new Date();
    let date = tempDate.getDate()  + ' ' + monthNames[tempDate.getMonth()] + ' ' + tempDate.getFullYear() 

    const { setTheme, theme, } = props

    const handleTheme = () => {
      if(theme === neon){
        setTheme(pink)
      } else {
        setTheme(neon)
      }
    }
    const { setSoundEnabled, soundEnabled, } = props

    const handleEnableSound = () => {
      const my_marah_audio = document.getElementById("marah_audio")
      const myAudioIcon = document.querySelector("#iconAudio");
      if(soundEnabled) {  
        myAudioIcon.classList.add(`${"grey"}`)
        my_marah_audio.muted = true
      } else {
        myAudioIcon.classList.remove(`${"grey"}`)
        my_marah_audio.muted = false
      }
      setSoundEnabled(!soundEnabled);
    }

    return (
        <>
          <div className={`${style.heading} mainOneText`}>
              <h2>The Period Periodical</h2>
              <p> {date} </p>
          </div>
        
          {/* Theme Toggle Icon */}
          <div className={`${style.toggleSwitch} main`}>
            <label onClick = {props.playSwitch} className = {`${style.switch} switch`}>
              <input type = "checkbox"/>
              <span onClick = {() => handleTheme()}  className = {style.slider}></span>
            </label>
          </div>

          <div className={`${style.soundIcon} main`}>
            <svg onClick = {handleEnableSound}  xmlns="http://www.w3.org/2000/svg" className={`${style.soundIconVector} soundIconVector`}viewBox="0 0 69.786 58">
              <path className = "headerIconColor" id="iconAudio" d="M14.539,45.5H0v-29H14.539Zm5.816-29v29L46.526,60V2Zm32.01,6.07a11.879,11.879,0,0,1-.02,16.829l3.545,3.547a16.872,16.872,0,0,0,.038-23.913L52.365,22.57Zm6.229-6.192a20.632,20.632,0,0,1-.049,29.232l3.635,3.637a25.761,25.761,0,0,0,.061-36.494Z" transform="translate(0 -2)"/>
            </svg>
          </div>
          
          <div className={`${style.elseIconContainer} main`}>
            <div className={`${style.elseIcon} main`}>
              <svg xmlns="http://www.w3.org/2000/svg" className = {`${style.elseIconVector} elseIconVector`} viewBox="0 0 71 19">
                <g id="iconElse" data-name="Group 6" transform="translate(-1702 -133)">
                  <circle className = "headerIconColor" id="Ellipse_29" data-name="Ellipse 29" cx="9.5" cy="9.5" r="9.5" transform="translate(1702 133)" />
                  <circle className = "headerIconColor" id="Ellipse_30" data-name="Ellipse 30" cx="9.5" cy="9.5" r="9.5" transform="translate(1728 133)" />
                  <circle className = "headerIconColor" id="Ellipse_31" data-name="Ellipse 31" cx="9.5" cy="9.5" r="9.5" transform="translate(1754 133)" />
                </g>
              </svg>
              </div>
            <div className={style.dropdown}>
              <div className={`${style.dropdownIcon} dropdownIcon`}>          
                  <FacebookShareButton url={shareUrl}>
                    <FacebookIcon  size={50} round />
                  </FacebookShareButton>
              </div>
              <div className={`${style.dropdownIcon} dropdownIcon`}>          
                  <TwitterShareButton
                    url={shareUrl}
                  >
                    <TwitterIcon size={50} round />
                  </TwitterShareButton>
              </div>
            </div>
          </div>


            
        </>
    )

}


export default Header

//initial inefficient audio playing system using MutationObserver

// const muteMe = (elem) => {
//   elem.muted = true;
// }
// const unMuteMe = (elem) => {
//   elem.muted = false;
// }
// // Select the node that will be observed for mutations
// const targetNode = document.getElementById('root');

// // Options for the observer (which mutations to observe)
// const config = { attributes: true, childList: true, subtree: true };


// let muted = false

// const startObserve = () => {
//   muted = !muted
//   const myAudioIcon = document.querySelector("#iconAudio");
//   if(muted) {  
//     myAudioIcon.classList.add(`${"grey"}`)
//   } else {
//     myAudioIcon.classList.remove(`${"grey"}`)
//   }


//   // Callback function to execute when mutations are observed
//   const callback = function(mutationsList, observer) {
   
//     for(let mutation of mutationsList) {
//           let elems = document.querySelectorAll("video, audio");
//           if (muted){
//             [].forEach.call(elems, function(elem) { muteMe(elem); });
//           } else {
//             [].forEach.call(elems, function(elem) { unMuteMe(elem); });
//           }
//             }
//               };

//         const observer = new MutationObserver(callback);
//         observer.observe(targetNode, config);

// }


